import { Component, ReactNode } from "react";

import { Button } from "@components/Button";
import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { ICON_PATHS } from "@configs/icons";

class ErrorBoundary extends Component<{ children: ReactNode; pathname?: string }> {
	state = {
		error: null as Error | null,
		pathname: null as string | null,
	};

	componentDidCatch(error: Error) {
		if (error) {
			console.error("ErrorBoundary: ", error);
		}
		const { pathname } = this.props;
		this.setState({ error, pathname: pathname ?? null });
	}

	componentDidUpdate(prevProps: { pathname?: string }) {
		const { error } = this.state;
		const { pathname } = this.props;
		if (error && prevProps.pathname !== pathname) {
			this.setState({ error: null, pathname: pathname ?? null });
		}
	}

	render() {
		const { error } = this.state;
		if (error) {
			return (
				<div className="relative z-max flex h-[75vh] items-center justify-center px-12.5 py-7.5 text-center leading-5.25">
					<div className="absolute top-1/2 left-1/2 z-max w-4/5 -translate-x-1/2 -translate-y-1/2">
						<Stack align="center" justify="center">
							<Image width={48} height={48} src={ICON_PATHS.ERROR} alt="error" />
							<Typography size="sm" align="center" className="mt-4">
								An error has occurred on this page.
							</Typography>
							<Typography size="sm" align="center">
								Please reload the page. If error appears
							</Typography>
							<Typography size="sm" align="center" className="mb-8">
								again connect with our support.
							</Typography>
							<Button onClick={() => window.location.reload()}>
								<Typography size="sm" weight="bold" align="center">
									Reload
								</Typography>
							</Button>
						</Stack>
					</div>
				</div>
			);
		}
		const { children } = this.props;
		return children;
	}
}

export default ErrorBoundary;
